<template>
  <div>
    <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top is-border-bottom">
      <div class="is-border-right is-border-left  columns is-marginless">
        <div
          class="column is-narrow is-flex is-padding-small">
          <span
            class="icon is-self-centered">
            <i class="fal fa-3x fa-file-alt"></i>
          </span>
        </div>
      </div>
      <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
        <div class="column">
          <span v-if="!editionMode">
            <a
              class="is-size-6 is-uppercase">{{ name }}</a>&nbsp;
            <a
              @click="editionMode = true"><span class="icon"><i class="fal fa-pencil"></i></span></a>
            <a
              @click="editionMode = true"><span class="is-underline"> Modifier</span></a>
          </span>
          <input
            v-else-if="editionMode"
            type="text"
            @click="$event.target.select()"
            :value="name"
            @input="$emit('updateName', $event.target.value)"
            class="input is-borderless is-small is-fullwidth is-shadowless"
            placeholder="Entrer le titre de la section">
          <span
            v-else
            class="is-size-6">{{ name }}</span>
        </div>
      </div>
      <div
        @click="$emit('deletePage', index)"
        class="column is-narrow has-background-white is-border-left is-flex is-padding">
        <span class="icon is-self-centered"><i
          class="fal fa-trash-alt"></i></span>
      </div>
      <div
        @click="showContent = !showContent"
        class="column is-narrow has-background-white is-border-right is-border-left is-flex is-padding">
        <span class="icon is-self-centered"><i
          :class="showContent ? 'fal fa-times' : 'fal fa-chevron-down'"></i></span>
      </div>
    </div>
    <div
      class="is-border-bottom"
      v-if="showContent">
      <custom-mention-section-bloc
        :key="'mention_fees'"
        :content="content"
        @updateComment="val => $emit('updateContent', val)">
      </custom-mention-section-bloc>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomPageBloc',
  components: {
    CustomMentionSectionBloc: () => import('./CustomMentionSectionBloc')
  },
  props: {
    name: {
      type: String
    },
    content: {
      type: String
    },
    index: {
      type: Number
    }

  },
  data () {
    return {
      showContent: false,
      editionMode: false,
      newName: null,
      newContent: null
    }
  },
  watch: {
  },
  created () {
    this.newName = this.name
    this.newContent = this.content
  },
  methods: {
  }
}
</script>
